// src/components/OneSignalInit.jsx
import { useEffect } from 'react';
import { useAuth } from '../Context/AuthContext';
import { apiFetch } from '../services/apiClient';

const ONESIGNAL_APP_ID = '0e82bbd5-36b1-48a0-81bc-707d8a160a9d';

export default function OneSignalInit() {
  const { user } = useAuth();

  useEffect(() => {
    if (!window.OneSignalDeferred) return;
    window.OneSignalDeferred.push(async function(OneSignal) {
      await OneSignal.init({
        appId: ONESIGNAL_APP_ID,
        notifyButton: { enable: false },
        allowLocalhostAsSecureOrigin: true,
      });
      // El permiso de push NO se pide acá: se pide recién cuando hay sesión
      // iniciada (ver efecto de abajo), no apenas entra un invitado.
    });
  }, []);

  useEffect(() => {
    if (!user?.id || !window.OneSignalDeferred) return;
    window.OneSignalDeferred.push(async function(OneSignal) {
      try {
        await OneSignal.login(String(user.id));
        // Pedimos permiso de push recién con sesión iniciada (momento con contexto).
        try { await OneSignal.Notifications.requestPermission(); } catch {}
        const subId = await OneSignal.User.PushSubscription.id;
        if (!subId) return;
        await apiFetch('/api/me/push-token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ pushToken: subId }),
        });
      } catch (err) {
        console.error('OneSignal error:', err);
      }
    });
  }, [user?.id]);

  return null;
}